"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNamespace = void 0;
exports.getNamespace = function (input) {
    switch (input) {
        case 'CHECKOUT':
            return 'CHECKOUT';
        case 'APPSHELL':
            return 'appShell';
        case 'BROADBAND':
            return 'Broadband';
        case 'DTVS':
            return 'DTVS';
        case 'IPTV':
            return 'IPTV';
        case 'CART':
            return 'CART';
        default:
            return 'CART';
    }
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/config/localdatastore/index.js
// module id = 74
// module chunks = 8